import { CloseIcon, IconButton, MenuIcon } from "@datagame/ui";
import { useState } from "react";
import classNames from "classnames/bind";

import { AppNavigationItems } from "../AppNavigationItems";

import styles from "./AppNavigationMobile.module.scss";

const cx = classNames.bind(styles);

export const AppNavigationMobile = () => {
  const [isOpen, setIsOpen] = useState(false);

  const wrapperClassNames = cx("wrapper", { isOpen });

  const toggleIsOpen = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className={wrapperClassNames}>
      <IconButton icon={isOpen ? <CloseIcon /> : <MenuIcon />} onClick={toggleIsOpen} className={styles.toggleButton} />
      <div className={styles.blur}></div>
      <div className={styles.itemsWrapper}>
        <AppNavigationItems toggleIsOpen={toggleIsOpen} />
      </div>
    </div>
  );
};
